import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Search, FilePlus, Package, UserSquare2, Menu, X } from 'lucide-react';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`print:hidden w-full md:w-[260px] bg-white z-10 flex flex-col md:relative fixed inset-x-0 ${isOpen ? 'h-auto' : 'h-auto'} md:h-full border-b md:border-b-0 md:border-r border-border`}>
            <div className="flex items-center justify-between p-5 border-b border-border">
                <div className="flex flex-col">
                    <div className="font-[800] text-primary text-[1.2rem]">TZ-QMS</div>
                    <div className="text-[0.75rem] text-text-gray">Quotation Manager</div>
                </div>
                <button
                    className="md:hidden block text-primary focus:outline-none"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            <div className={`py-5 flex-grow ${isOpen ? 'flex flex-col' : 'hidden md:flex md:flex-col'}`}>
                <NavLink
                    to="/builder"
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => `px-6 py-4 flex items-center gap-4 text-text-gray font-medium transition-all duration-200 border-l-4 border-transparent hover:bg-slate-100 hover:text-primary ${isActive ? 'bg-yellow-50 text-accent border-accent' : ''}`}
                >
                    <FilePlus size={20} /> New Quotation
                </NavLink>
                <NavLink
                    to="/dashboard"
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => `px-6 py-4 flex items-center gap-4 text-text-gray font-medium transition-all duration-200 border-l-4 border-transparent hover:bg-slate-100 hover:text-primary ${isActive ? 'bg-yellow-50 text-accent border-accent' : ''}`}
                >
                    <Search size={20} /> Quotation Preview
                </NavLink>
                <NavLink
                    to="/items"
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => `px-6 py-4 flex items-center gap-4 text-text-gray font-medium transition-all duration-200 border-l-4 border-transparent hover:bg-slate-100 hover:text-primary ${isActive ? 'bg-yellow-50 text-accent border-accent' : ''}`}
                >
                    <Package size={20} /> Particulars Base
                </NavLink>
                <NavLink
                    to="/executives"
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) => `px-6 py-4 flex items-center gap-4 text-text-gray font-medium transition-all duration-200 border-l-4 border-transparent hover:bg-slate-100 hover:text-primary ${isActive ? 'bg-yellow-50 text-accent border-accent' : ''}`}
                >
                    <UserSquare2 size={20} /> Sales Executives
                </NavLink>
            </div>
        </div>
    );
};

export default Sidebar;
